module.exports = __webpack_public_path__ + "img/padlock.173aaabe.svg";